import React, { useEffect, useState } from 'react';
import '../styles/signin.css';
import { Link, useNavigate } from "react-router-dom";
import { Button, Form } from 'react-bootstrap';
import logo from '../assets/svg/logo-login-v1.png';
import bata from '../assets/images/bata.png';
import calvin from '../assets/images/calvinklein.png';
import citizen from '../assets/images/citizen.png';
import crocs from '../assets/images/crocs.png';
import barbour from '../assets/images/barbour.png';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { adminLogin, forgotPassword, otpResend, otpVerify, updateFCM } from '../api/context/auth';
import OtpInput from 'react-otp-input';
import { BsEye, BsEyeSlash } from 'react-icons/bs';
import { onMessageListener, requestForToken } from '../firebase';
export const SignIn = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState('login');
    const [seconds, setSeconds] = useState(30);
    const [otp, setOtp] = useState('')
    const [otpTo, setOtpTo] = useState()
    const [submittedEmail, setSubmittedEmail] = useState('');
    const [formValues, setFormValues] = useState({})
    const [rememberMe, setRememberMe] = useState(false);
    const [showPassword, setShowPassword] = useState({
        password: false,
    });

    const togglePasswordVisibility = (fieldName) => {
        setShowPassword(prev => ({ ...prev, [fieldName]: !prev[fieldName] }));
    };

    const handleChange = (otp) => {
        setOtp(otp);
    }

    const formik = useFormik({
        initialValues: {
            email: "",
            password: "",
        },
        validationSchema: Yup.object().shape({
            email: Yup.string().matches(/(\<|^)[\w\d._%+-]+@(?:[\w\d-]+\.)+(\w{2,})(\>|$)/, 'Enter a valid email')
                .required('Required'),
            password: Yup.string()
                .required('Required'),
        }),
        onSubmit: (values) => {
            setLoading(true);
            const payload = {
                email: values.email,
                password: values.password
            };
            adminLogin(payload)((response) => {
                if (response && response.status) {

                    let notificationResponse = null;

                    const onResponse = (error, token) => {
                        if (error) {
                            // Display error as a toast
                            // toast.error(error);
                            console.log(error);

                        } else {
                            notificationResponse = token; // Store token in the variable


                            localStorage.setItem("fcmToken", token)
                            updateFCM({ fcmToken: token })((res) => {
                                if (res?.status) {
                                    //console.log(res?.data);

                                }
                            })
                            // Optionally send the token to your server here
                        }
                    };

                    const requestForTokenAndUpdate = async () => {
                        const token = await requestForToken();
                        if (token) {
                            localStorage.setItem("fcmToken", token);
                            updateFCM({ fcmToken: token });
                        }
                    };
                    requestForTokenAndUpdate();

                    if (rememberMe) {
                        localStorage.setItem('rememberedEmail', values.email);
                        localStorage.setItem('rememberedPassword', values.password);
                    } else {
                        localStorage.removeItem('rememberedEmail');
                        localStorage.removeItem('rememberedPassword');
                    }
                    const permissions = response?.data?.permissionCodes
                    localStorage.setItem('token', response?.data?.accessToken);
                    localStorage.setItem('permissions', JSON.stringify(permissions));
                    localStorage.setItem('user', JSON.stringify(response?.data?.adminData));

                    toast.success(response?.message)
                    formik.resetForm();
                    setLoading(false);

                    let user = JSON.parse(localStorage.getItem('user'))
                    if (user?.userType === 'customerSupport') {
                        navigate('/chat-support');
                    } else {
                        navigate('/');
                    }
                }
                else {
                    toast.error(response?.response?.data?.message);
                    setLoading(false);
                }
            });
        },
    });

    const forgotformik = useFormik({
        initialValues: {
            email: "",
        },
        validationSchema: Yup.object().shape({
            email: Yup.string().matches(/(\<|^)[\w\d._%+-]+@(?:[\w\d-]+\.)+(\w{2,})(\>|$)/, 'Enter a valid email')
                .required('Required'),
        }),
        onSubmit: (values) => {
            setLoading(true);
            const payload = {
                email: values.email,
            };
            forgotPassword(payload)((response) => {
                if (response && response.statusCode == 200) {
                    toast.success(response?.message)
                    formik.resetForm();
                    setLoading(false);
                    setOtpTo(values.email)
                    setSubmittedEmail(values.email);
                    setForm('otp')
                }
                else {
                    toast.error(response?.response?.data?.message);
                    setLoading(false);
                }
            });
        },
    });

    const otpformik = useFormik({
        initialValues: {
            email: "",
            otp: "",
            password: "",
        },
        validationSchema: Yup.object().shape({
            // email: Yup.string().matches(/(\<|^)[\w\d._%+-]+@(?:[\w\d-]+\.)+(\w{2,})(\>|$)/, 'Enter a valid email')
            //     .required('Required'),
            // otp: Yup.string()
            //     .required('Required'),
            password: Yup.string()
                .required('Required'),
        }),
        onSubmit: (values) => {
            setLoading(true);
            const payload = {
                email: submittedEmail,
                otp: otp,
                password: values.password,
            };
            otpVerify(payload)((response) => {
                if (response && response.statusCode == 200) {
                    setOtp('');
                    setForm('login');
                    setLoading(false);
                    toast.success(response?.message)
                }
                else {
                    toast.error(response?.response?.data?.message);
                    setLoading(false);
                }
            });
        },
    });

    const forgotPass = () => {
        setForm("forgot")
    }



    const resendOtp = () => {
        setLoading(true);
        const payload = {
            email: submittedEmail,
        };
        forgotPassword(payload)((response) => {
            if (response && response.statusCode == 200) {
                setForm('otp')
                setSeconds(30)
                setLoading(false);
                toast.success("Resend OTP Sent Successfully")
            }
            else {
                toast.error(response?.response?.data?.message);
                setLoading(false);
            }
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const trimmedValue = value.replace(/^\s+/, '');
        formik.setFieldValue(name, trimmedValue);
    };

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (form == 'otp') {
                setSeconds(seconds => seconds - 1);
                if (seconds <= 0) {
                    clearInterval(intervalId);
                }
            }
        }, 1000);
        return () => clearInterval(intervalId);
    }, [form]);

    useEffect(() => {
        let token = localStorage.getItem('token');
        let user = JSON.parse(localStorage.getItem('user'))
        if (token) {
            if (user?.userType === 'customerSupport') {
                navigate('/chat-support');
            } else {
                navigate('/');
            }
        }
    }, []);

    useEffect(() => {
        const rememberedEmail = localStorage.getItem('rememberedEmail');
        const rememberedPassword = localStorage.getItem('rememberedPassword');
        if (rememberedEmail && rememberedPassword) {
            // Populate form fields with stored credentials
            formik.setValues({
                email: rememberedEmail,
                password: rememberedPassword,
            });
            // Also set the "Remember me" checkbox as checked
            setRememberMe(true);
        }
    }, []);

    onMessageListener().then(payload => {
        // console.log(payload);
    }).catch(err => console.log('failed: ', err));


    return (

        <div className='login-card'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-sm-12'>
                        <div className='row'>
                            <div className='col-lg-6 p-0'>
                                <div className='left_wrapper'>
                                    <div className='img_wrapper'>
                                        <img src={logo} className='img-fluid logo_img' alt='Logo' />
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6 p-0'>
                                <div className='right_wrapper'>
                                    <div className='right_wrapper_bottom'>
                                        {form === 'login' && (
                                            <>
                                                <h3>Log In / <span style={{ textDecoration: 'underline', cursor: 'pointer',color:'#007d7bff' }} onClick={() => navigate('/register-vendor')}>Register</span></h3>
                                                <Form className='login_form_wrapper' onSubmit={formik.handleSubmit}>
                                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                                        <Form.Label>Email address</Form.Label>
                                                        <Form.Control
                                                            type="email"
                                                            placeholder=""
                                                            name="email"
                                                            value={formik.values?.email}
                                                            onChange={handleInputChange}
                                                            isValid={formik.touched.email && !formik.errors.email}
                                                            isInvalid={formik.touched.email && !!formik.errors.email}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{formik.errors.email}</Form.Control.Feedback>
                                                    </Form.Group>

                                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                                        <Form.Label>Password</Form.Label>
                                                        <div className='eye_icon_wrapper'>
                                                            <Form.Control
                                                                type={showPassword.password ? 'text' : 'password'}
                                                                placeholder=""
                                                                name='password'
                                                                value={formik.values?.password}
                                                                onChange={handleInputChange}
                                                                isValid={formik.touched.password && !formik.errors.password}
                                                                isInvalid={formik.touched.password && !!formik.errors.password}
                                                            />
                                                            <Form.Control.Feedback type="invalid">{formik.errors.password}</Form.Control.Feedback>
                                                            {showPassword.password ? (
                                                                <BsEye className='eye_icon' onClick={() => togglePasswordVisibility("password")} />
                                                            ) : (
                                                                <BsEyeSlash className='eye_icon' onClick={() => togglePasswordVisibility("password")} />
                                                            )}
                                                        </div>

                                                    </Form.Group>
                                                    <div className='remember_forgot_wrapper'>
                                                        <Form.Group className="" controlId="formBasicCheckbox">
                                                            <span className="remember">
                                                                <Form.Check
                                                                    type="checkbox"
                                                                    aria-label="Remember Me"
                                                                    checked={rememberMe}
                                                                    onChange={(e) => setRememberMe(e.target.checked)}
                                                                />{' '}
                                                                Remember me
                                                            </span>
                                                        </Form.Group>
                                                        <Button className='forgot_pass' onClick={() => forgotPass()}>Forgot Password?</Button>
                                                    </div>

                                                    <Button className='login_btn' type="submit" disabled={loading}>
                                                        {loading ? "Loading" : "Log In"}
                                                    </Button>
                                                </Form>
                                            </>
                                        )}

                                        {form === 'forgot' && (
                                            <>
                                                <h3>Forgot Password</h3>
                                                <Form className='login_form_wrapper' onSubmit={forgotformik.handleSubmit}>
                                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                                        <Form.Label>Email address</Form.Label>
                                                        <Form.Control
                                                            type="email"
                                                            placeholder=""
                                                            name="email"
                                                            value={forgotformik.values?.email}
                                                            onChange={forgotformik.handleChange}
                                                            isValid={forgotformik.touched.email && !forgotformik.errors.email}
                                                            isInvalid={forgotformik.touched.email && !!forgotformik.errors.email}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{forgotformik.errors.email}</Form.Control.Feedback>
                                                    </Form.Group>
                                                    <div className='remember_forgot_wrapper justify-content-end'>
                                                        <Link className='forgot_pass' onClick={() => navigate(-1)}>Back to login</Link>
                                                    </div>
                                                    <Button className='login_btn' type="submit" disabled={loading}>
                                                        {loading ? "Loading" : "Submit"}
                                                    </Button>
                                                </Form>
                                            </>
                                        )}
                                        {form === 'otp' && (
                                            <React.Fragment>
                                                <div className="otp-box">
                                                    <div className="otp-info">
                                                        <div>
                                                            <h3>Enter Verification Code</h3>
                                                        </div>
                                                        <p>We have send you a verification code to <span style={{ color: "#007EA9" }}>{otpTo}</span></p>
                                                    </div>
                                                    <Form className='login_form_wrapper' onSubmit={otpformik.handleSubmit}>
                                                        <div className="otp-inputs">
                                                            <Form.Label className='text-start'>OTP</Form.Label>
                                                            <OtpInput
                                                                containerStyle="inputs"
                                                                value={otp}
                                                                isInputNum={true}
                                                                onChange={handleChange}
                                                                numInputs={6}
                                                                separator={false}
                                                                inputStyle={{ width: "54px", height: "54px", borderRadius: "12px", border: "1px solid #EDEFFA", color: "var(--muted)" }}
                                                                renderInput={(props) => <input {...props} />}
                                                            />
                                                            <Form.Group className="mb-3 mt-3" controlId="formBasicPassword">
                                                                <Form.Label className='text-start'>Password</Form.Label>
                                                                <div className='eye_icon_wrapper'>
                                                                    <Form.Control
                                                                        type={showPassword.password ? 'text' : 'password'}
                                                                        placeholder=""
                                                                        name='password'
                                                                        value={otpformik.values?.password}
                                                                        onChange={otpformik.handleChange}
                                                                        isValid={otpformik.touched.password && !otpformik.errors.password}
                                                                        isInvalid={otpformik.touched.password && !!otpformik.errors.password}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{otpformik.errors.password}</Form.Control.Feedback>
                                                                    {showPassword.password ? (
                                                                        <BsEye className='eye_icon' onClick={() => togglePasswordVisibility("password")} />
                                                                    ) : (
                                                                        <BsEyeSlash className='eye_icon' onClick={() => togglePasswordVisibility("password")} />
                                                                    )}
                                                                </div>
                                                            </Form.Group>
                                                            {seconds > 0 ? (
                                                                <p>Resend code in {seconds} sec</p>
                                                            ) : (
                                                                <p>Didn&apos;t receive OTP?
                                                                    <span
                                                                        style={{ color: "#007EA9" }}
                                                                        role="button"
                                                                        onClick={!loading ? () => resendOtp(formValues, otpTo) : null}
                                                                    >
                                                                        {loading ? " LOADING..." : " RESEND OTP"}
                                                                    </span>
                                                                </p>
                                                            )}
                                                        </div>
                                                        <Button className='reg_btn' type='submit' disabled={loading}>{loading ? "Loading" : "Submit"}</Button>
                                                    </Form>

                                                </div>

                                            </React.Fragment>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
